/**
 * Twilio Voice JS SDK `Device` edge names.
 * @see https://www.twilio.com/docs/voice/sdks/javascript/twiliodevice#edge
 */
export type TwilioVoiceEdge =
  | 'ashburn'
  | 'dublin'
  | 'frankfurt'
  | 'roaming'
  | 'sao-paulo'
  | 'singapore'
  | 'sydney'
  | 'tokyo'
  | 'umatilla';

const REGION_TO_EDGE: Record<string, TwilioVoiceEdge> = {
  ashburn: 'ashburn',
  au1: 'sydney',
  br1: 'sao-paulo',
  de1: 'frankfurt',
  dublin: 'dublin',
  'eu-ie1': 'dublin',
  frankfurt: 'frankfurt',
  // Twilio "global low latency" — nearest edge to the browser, not the PSTN egress.
  gll: 'roaming',
  ie1: 'dublin',
  jp1: 'tokyo',
  roaming: 'roaming',
  'sao-paulo': 'sao-paulo',
  saopaulo: 'sao-paulo',
  sg1: 'singapore',
  singapore: 'singapore',
  sydney: 'sydney',
  tokyo: 'tokyo',
  us1: 'ashburn',
  us2: 'umatilla',
  umatilla: 'umatilla',
};

/**
 * Normalizes tenant `regionId` (ie1, dublin, gll, …) to a Voice SDK `edge`.
 * `gll` / missing → roaming (nearest to the agent). UK PSTN still egresses ie1,
 * so UK tenants should set RegionId to ie1 to avoid Singapore/Ashburn vs Dublin.
 * Dublin also lists Frankfurt as failover.
 */
export function resolveTwilioVoiceEdge(regionId?: string | null): string | string[] {
  const key = String(regionId ?? '').trim().toLowerCase();
  const mapped = key ? REGION_TO_EDGE[key] : undefined;

  if (mapped === 'dublin') {
    return ['dublin', 'frankfurt'];
  }
  if (mapped) {
    return mapped;
  }
  return 'roaming';
}

/** Stable key for comparing Device edge selection across setupTwilio calls. */
export function twilioVoiceEdgeKey(edge: string | string[]): string {
  return Array.isArray(edge) ? edge.join(',') : edge;
}
